import { render, staticRenderFns } from "./bizcompTitleDc.vue?vue&type=template&id=c2a50672"
import script from "./bizcompTitleDc.vue?vue&type=script&lang=js"
export * from "./bizcompTitleDc.vue?vue&type=script&lang=js"
import style0 from "./bizcompTitleDc.vue?vue&type=style&index=0&id=c2a50672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports